<template>
    <div
    class="wf-relative"
    :class="! previewMode ? 'wf-border wf-border-transparent hover:wf-border-blue-300 wf-pt-8 wf-pb-2 wf-px-1' : ''"
    @mouseover="hover = true"
    @mouseleave="hover = false"
  >
    <EditorOptions
      parent="component"
      name="Form"
      v-show="hover && ! previewMode"
      :options="menuOptions"
      :parentModule="parentModule"
    />
    <div :class="elementClasses(classes('classes'), classes('customClasses'))" :id="id">
      <draggable
        class="wf-w-full"
        v-model="formRows"
        group="formRows"
        handle=".form-row-handle"
      >
        <EditorFormRow  v-for="formRow in formRows" :key="formRow.id" :parentModule="parentModule"/>
      </draggable>
        <button
          v-show="! previewMode"
          @click.prevent="addFormRow"
          class="wf-w-full wf-uppercase wf-text-xs wf-font-bold wf-tracking-wide wf-self-end wf-text-gray-500 wf-text-center wf-border wf-border-dashed wf-border-gray-500 wf-px-4 wf-h-10 wf-w-full"
        >
          <i class="fas fa-plus wf-mr-4"></i>add Form Row
        </button>
    </div>
  </div>
</template>

<script>
  import draggable from 'vuedraggable'
  import EditorFormInput from './EditorFormInput'
  import EditorFormButton from './EditorFormButton'
  import { FormRowFactory } from '../factories/FormRowFactory'
  import EditorComponent from '../contracts/EditorComponent'
  export default EditorComponent.extend({
    components: {draggable, EditorFormInput, EditorFormButton},
    computed: {
      inputClasses() {
        return this.$store.getters[`${this.module}/classes`](this.element, 'inputClasses')
      },
      inputStyles() {
        return this.$store.getters[`${this.module}/styles`](this.element, 'inputStyles')
      },
      buttonClasses() {
        return this.$store.getters[`${this.module}/classes`](this.element, 'buttonClasses')
      },
      buttonStyles() {
        return this.$store.getters[`${this.module}/styles`](this.element, 'buttonStyles')
      },
      showPlaceholder() {
        return this.content.showPlaceholder
      },
      showLabels() {
        return this.content.showLabels
      },
      formRows: {
        get() {
          return this.content.rows
        },
        set(value) {
          this.addToObject(this.module, {rows: value}, 'content', null, {}, true, this.parentModule)
        }
      }
    },
    methods: {
      addFormRow() {
        let rows = [...this.content.rows, (new FormRowFactory).create()]
        this.addToObject(this.module, {rows: rows}, 'content', null, {}, true, this.parentModule)
      }
    }
  })
</script>